<template>
  <div id="content">
    <v-card>
      <v-responsive max-height="500">
        <v-img class="white--text" :src="banner" max-height="500">
          <v-layout fill-height justify-center align-center>
            <h1 class="banner-title">About</h1>
          </v-layout>
        </v-img>
      </v-responsive>
    </v-card>
    <v-container>
      <v-layout justify-center>
        <v-flex class="text-xs-center" xs10 md8>
          <p class="body-1">Our name says something about who we are</p>
          <p class="headline">Union with Christ Community Church.</p>
          <p
            class="subheading"
          >As believers we are one with Christ through the indwelling of the Holy Spirit, and we experience intimate union with God through his son Jesus Christ. This union with Christ is what forms us into the body of Christ – His church.</p>
          <p
            class="subheading"
          >Community clearly identifies the sphere of our influence. As members of one body, we seek to preserve the unity of the Spirit in the bond of peace. As a light in our community, we seek to make Christ known through His love.</p>
          <p
            class="subheading"
          >Church reminds us that we are not a club with earthly or temporal purposes. Our goal, directions, methods, standards and purpose are all defined and charted by God. We exist for the audience of One. As His church, we are continuing the ministry that Jesus started, which is to connect mankind with our amazing God. And we would love to connect with you.</p>
        </v-flex>
      </v-layout>
    </v-container>
    <mission-and-vision></mission-and-vision>
    <v-container grid-list-lg>
      <h5 class="headline text-xs-center text-uppercase letter-spacing-1">Distinctives</h5>
      <v-divider class="my-4 grey"></v-divider>
      <v-layout row wrap>
        <v-flex d-flex v-for="(distinctive, i) in distinctives" :key="i" xs12 sm6 md4 lg3>
          <v-card class="elevation-4">
            <v-card-title primary-title>
              <div>
                <div class="headline mb-3">{{ distinctive.title }}</div>
                <span>{{ distinctive.description }}</span>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      <v-divider class="my-4 grey"></v-divider>
      <h5 class="headline text-xs-center text-uppercase letter-spacing-1">Leadership</h5>
      <v-layout>
        <v-flex class="text-xs-center my-4">
          <v-avatar size="150" class="elevation-4">
            <img :src="pastors[0].img" alt="avatar">
          </v-avatar>
          <v-card flat>
            <v-card-title primary-title class="justify-center">
              <div>
                <div class="headline">{{ pastors[0].name }}</div>
                <span class="grey--text">Head Pastor</span>
              </div>
            </v-card-title>

            <v-card-actions class="justify-center">
              <v-btn flat @click="pastors[0].show = !pastors[0].show" color="purple">
                <span>Show More</span>
                <v-icon right>{{ pastors[0].show ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-slide-y-transition>
              <v-card-text v-show="pastors[0].show">{{ pastors[0].desc }}</v-card-text>
            </v-slide-y-transition>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import AuthenticationService from "@/services/AuthenticationService";
import MissionAndVision from "./MissionAndVision";
export default {
  name: "About",
  components: {
    MissionAndVision
  },
  data() {
    return {
      email: "testing@gmail.com",
      password: "123456",
      banner: require("../assets/banner/about-banner.jpg"),
      distinctives: [
        {
          title: "Inerrancy of the Bible",
          description:
            "We believe the Bible to be the inspired and inerrant Word of God. It is the only source and standard for matters of faith and practice for the believer."
        },
        {
          title: "Salvation is by Grace Through Faith Alone",
          description:
            "We believe that salvation is by grace alone, through faith alone, in Christ alone, and to the glory of God alone and that the gospel call to faith presupposes that sinners must repent from their sins and yield to Christ’s authority."
        },
        {
          title: "Sovereignty of God in Salvation",
          description:
            "We believe that GOD, before the foundation of the world, sovereignly elects in Christ those whom He graciously regenerates, saves, and sanctifies."
        },
        {
          title: "Eternal Security",
          description:
            "We believe that all the redeemed once saved are kept by God’s power and are thus secure in Christ forever."
        },
        {
          title: "Cessation of Sign Gifts or Apostolic Gifts",
          description:
            "We believe that miracles, tongues and vision are sign gifts to validate the gospel message and its messenger. And that the evidence of Scripture and history indicate that tongues ceased in the Apostolic age and that there are no more apostles nor New Testament prophets today."
        },
        {
          title: "Spiritual Equality of Man and Woman but with Different Roles",
          description:
            "We believe that man and woman are equall spiritually, yet they have different intended roles both in the ministry and in the home."
        },
        {
          title: "Mission of Local Churches",
          description:
            "We believe that the primary tasks of a local church are to make disciples by proclaiming the Gospel and to shepherd believers to spiritual maturity."
        },
        {
          title: "Important Role of a Local Church and Church Membership",
          description:
            "We believe that every believer should be a member of and committed and accountable to a local church."
        },
        {
          title: "Plurality of Godly Leaders",
          description:
            "We believe that Jesus Christ is the invisible head of our church and He is ruling through godly elders."
        },
        {
          title: "Expository Preaching as the means to Maturity",
          description:
            "We believe that only expository preaching best accomplishes the call to proclaim the whole counsel of God. And it is the foundation of all our ministries."
        },
        {
          title: "Israel and Church Different and Distinct",
          description:
            "We believe that the Church today does not replace the nation Israel. God will fulfill all His promises to the nation Israel."
        },
        {
          title: "Pre-Mil, Pre-Trib Return of Jesus Christ",
          description:
            "We believe that the physical and literal return of Jesus Christ to the earth precedes the establishing of His physical kingdom here on earth."
        }
      ],
      pastors: [
        {
          name: "Pastor Billy Arcayan",
          desc:
            "My name is Billy, and I’m married to my lovely wife, Grace. Grace loves to cook and she is a tecky person. She has the gift of hospitality, faith, help and service. I love outdoor games, reading, and eating. In 1994, I began my graduate studies at the Biblical Seminary of the Philippines (BSOP). My three-and-a-half years at BSOP were enriching and transformative. After receiving my Master of Divinity from BSOP, I served and was ordained at United Evangelical Church of Malabon. I also had opportunity leading Quezon City Evangelical Church for a period of time, after which, I accepted the call of God to start and serve as the Senior Pastor- Teacher of Union with Christ Community Church (UCCC) in 2012 up to the present. God has blessed my wife and I with four children— Nas, Matts, Kaiser, and Arielle. Our desire, as a family, is for God to do a great work through us in reaching our community. Personally, I take Paul's charge to Timothy, \"preach the word,\" very seriously. And I’m fully convinced the Bible has the answer for all of life's problems, and that it is the final authority for life.",
          img: require("../assets/billy_300x300.jpg"),
          show: false
        }
      ]
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/About.vue